import React from 'react';
import { Title, Subtitle, Grid, GridItem } from '@landing/ui';
import { Container } from 'components/UI';
import * as styles from './ContentWithItems.module.scss';

export default function ContentWithItems({
  id,
  title,
  titleTag = 'h2',
  subtitle,
  description,
  background,
  innerBackground,
  padding,
  theme = 'white',
  Item,
  items = [],
  gutterX = '30px',
  gutterY = '30px',
  colsXsm = 1,
  colsSm = 1,
  colsMd = 2,
  colsLg = 2,
  onItemClick,
  BottomContent,
  ...rest
}) {
  return (
    <Container id={id} theme="outer" background={background} padding={padding}>
      <Container theme="inner" background={innerBackground ?? background}>
        <div className={styles.wrapper}>
          <Title tag={titleTag} size="h2" color={theme}>
            {title}
          </Title>
          {subtitle && (
            <Subtitle size="lg" color={theme}>
              {subtitle}
            </Subtitle>
          )}
          {description && (
            <Subtitle size="lg" color={theme}>
              {description}
            </Subtitle>
          )}
          <div className={styles.layout}>
            <Grid
              xsm={{ cols: colsXsm }}
              sm={{ cols: colsSm }}
              md={{ cols: colsMd }}
              lg={{ cols: colsLg }}
              xl={{ cols: colsLg }}
              gutterY={gutterY}
              gutterX={gutterX}
            >
              {items.map(item => (
                <GridItem key={item.title}>
                  <Item
                    theme={theme}
                    onClick={onItemClick ? () => onItemClick(item) : null}
                    {...item}
                    {...rest}
                  />
                </GridItem>
              ))}
            </Grid>
          </div>
          {BottomContent}
        </div>
      </Container>
    </Container>
  );
}
